<template>
  <router-link tag="div" :to="data.link" class="invite__list__item">
    <div :style="$bgd(data.img)" class="top"></div>
    <div :style="'color:' + data.newColor" v-if="data.isNew" class="new">
      <i class="anyteachicon anyteach-zuixinhuodong" />新活动
    </div>
    <div class="bottom" :style="'background:' + data.background">
      <div class="text">
        <h1 :style="'color:' + data.color">{{ data.title }}</h1>
        <h2 :style="'color:' + data.subColor">{{ data.subtitle }}</h2>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: "InviteListItem",
  props: ["data"],
}
</script>

<style lang="scss" scoped>
// @import "../../../../static/css/public.scss";
$deep-shadow: 0 0 20px -5px #cacaca;
.invite__list__item {
  width: 100%;
  height: 190px;
  margin: 0 auto 20px auto;
  transition: all 0.1s;
  box-shadow: $deep-shadow;
  border: 1px solid #eee;
  border-radius: 4px;
  position: relative;
  max-width: 390px;
  &:active {
    opacity: 0.6;
  }
}
.invite__list__item:first-of-type {
  margin-top: 10px;
}

.new {
  position: absolute;
  font-size: 0.8rem;
  @include avenir-demi();
  letter-spacing: 1.5px;
  top: 10px;
  left: 15px;
  i {
    font-size: inherit;
    padding: 0 5px 0 0;
  }
}
.top,
.bottom {
  width: 100%;
  height: 100%;
  border-radius: 4px;
}
.bottom {
  position: absolute;
  top: 0;
  left: 0;
  color: white;
  display: flex;
  align-items: flex-end;
  .text {
    padding: 0 15px 10px 15px;
    * {
      color: white;
    }
  }
  h1 {
    font-size: 1.2rem;
    margin: 10px 0 5px 0;
  }
  h2 {
    font-size: 0.9rem;
    font-weight: 400;
    @include avenir();
    line-height: 1.2;
  }
}
</style>
